import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type ReactRendererService from 'garaje/services/react-renderer';
import type StateService from 'garaje/services/state';
import type { Root } from 'react-dom/client';
interface PoliciesComponentProps {
  locationId: string | null;
}

export default class VisitorsSettingsPoliciesIndexController extends Controller {
  @service declare reactRenderer: ReactRendererService;
  @service declare state: StateService;

  private root?: Root;

  @action
  async injectComponent(): Promise<void> {
    const { Policies } = await import('reactRichComponents/visitors/Policies');

    this.root = await this.reactRenderer.render(Policies, 'react__visitors__settings__policies', {
      locationId: this.state.currentLocation?.id ?? null,
    } satisfies PoliciesComponentProps);
  }

  @action
  destroyComponent(): void {
    if (this.root) {
      this.reactRenderer.unmount(this.root);
      this.root = undefined;
    }
  }
}
